import React from "react";
import { AppStreamState, AppStreamConnectionState } from "common/components/appstream";
import { useActiveSessions } from "pages/dashboard/components/active_sessions";
import FormattedDuration from "react-intl-formatted-duration";
import { Badge, Button, ProgressBar } from "react-bootstrap";

const MetricBadge = ({ value }) => {

    if (value == null) return <span className="text-muted">-</span>;

    const rounded = Math.round(value);
    let variant = 'success';
    if (rounded >= 80) variant = 'danger';
    else if (rounded >= 60) variant = 'warning';

    return (
        <Badge bg={variant}>
            {rounded}%
        </Badge>
    );

};

const ConnectionQualityBadge = ({ rtt_ms, packet_loss_pct }) => {

    if (rtt_ms == null && packet_loss_pct == null)
        return <span className="text-muted">-</span>;

    const rtt = rtt_ms ?? 0;
    const loss = packet_loss_pct ?? 0;

    let label = 'Good';
    let variant = 'success';

    if (rtt > 150 || loss > 2) {

        label = 'Fair';
        variant = 'warning';

    }

    if (rtt > 300 || loss > 5) {

        label = 'Poor';
        variant = 'danger';

    }

    const rttLabel = rtt_ms != null ? ` (${Math.round(rtt_ms)}ms)` : '';

    return (
        <Badge bg={variant}>
            {label}{rttLabel}
        </Badge>
    );

};

export const ActiveSessionsTableRow = props => {

    const { session } = props;
    const { appstream_session_id, appstream_state, appstream_connection_state, appstream_user_id, sms_ctag, sms_user_name,
        sms_application_name, duration_seconds, cpu_usage, memory_usage, rtt_ms, packet_loss_pct } = session;

    const { handleViewDetails, handleExpireSession } = useActiveSessions();

    return (
        <tr>
            <td className="align-middle">
                <AppStreamState appstream_state={appstream_state}/>
            </td>
            <td className="align-middle">
                <AppStreamConnectionState appstream_connection_state={appstream_connection_state}/>
            </td>
            <td className="align-middle">
                {sms_application_name}
            </td>
            <td className="align-middle">
                {sms_ctag}
            </td>
            <td className="align-middle">
                <small>
                    {appstream_user_id || '-'}
                </small>
            </td>
            <td className="align-middle">
                <small>
                    {sms_user_name || '-'}
                </small>
            </td>
            <td className="align-middle">
                <MetricBadge value={cpu_usage}/>
            </td>
            <td className="align-middle">
                <MetricBadge value={memory_usage}/>
            </td>
            <td className="align-middle">
                <ConnectionQualityBadge rtt_ms={rtt_ms} packet_loss_pct={packet_loss_pct}/>
            </td>
            <td className="align-middle">
                <FormattedDuration
                    seconds={duration_seconds}
                    unitDisplay="short"
                    format="{minutes} {seconds}"
                />
            </td>
            <td className="align-end">
                <div className="d-flex">
                    <Button
                        size="sm"
                        className="me-2"
                        variant="outline-secondary"
                        onClick={() => handleViewDetails(session)}
                    >
                        Details
                    </Button>
                    <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => handleExpireSession(appstream_user_id)}
                        disabled={!appstream_session_id}
                    >
                        Expire
                    </Button>
                </div>
            </td>
        </tr>
    );

};